module.exports = __webpack_public_path__ + "static/img/kjhf_add_group_success.76e4a49.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/kjhf_add_group_success.jpeg
// module id = 1235
// module chunks = 0